// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"219":"f40209ac","256":"cffaada7","318":"cffaada7"}[chunkId] + ".chunk.css";
};